module.exports = __webpack_public_path__ + "img/d6a05f3.jpg";